module.exports = __webpack_public_path__ + "img/clock-check.f69bc4b1.svg";